<template>
  <div>
    <el-tree
        ref='tree'
        :data='permissionsList'
        :default-checked-keys="checkedNodeIds"
        :props='defaultProps'
        node-key='id'
        show-checkbox
      >
    </el-tree>
<!--    {{ newData }}-->
<!--    <el-tree-->
<!--        ref='tree'-->
<!--        :data='newData'-->
<!--        :props='defaultProps'-->
<!--        node-key='id'-->
<!--        style="width: 100px;display: inline-block;border: 1px solid blue">-->
<!--    </el-tree>-->
  </div>
</template>

<script>
export default {
  name: 'PermissionMap',
  props: {
    permissionsList: {
      type: Array,
      default() {
        return []
      }
    },
    checkedNodeIds:{
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'remarks'
      },
      newData: []
    }
  },
  methods: {
    setCheckedKeys() {
      // this.$refs.tree.setCheckedKeys(this.checkedNodeIds);
    },
  },
  mounted() {


  }
}
</script>

<style scoped>

</style>
